const WA_LINK = "https://wa.me/243808631779?text=Bonjour%20je%20souhaite%20m'inscrire%20à%20une%20formation";

const programs = [
  'Électricité', 'Énergie Solaire', 'Fibre Optique', 'Téléphonie GSM',
  'Sécurité & CCTV', 'Développement Web', 'Intelligence Artificielle', 'Business & Entrepreneuriat',
];

export default function Footer() {
  return (
    <footer className="bg-[#060e1c] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="https://static.readdy.ai/image/78c9a73689059983cd7950cce3ca9afd/7655e67726ec117c28b05a02aa0b32f2.jpeg"
                alt="Campus Négus Tech"
                className="h-12 w-12 rounded-full object-cover"
              />
              <span className="font-black text-xl">
                Campus <span className="text-[#f5c518]">Négus</span> Tech
              </span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed mb-6">
              Centre de formation professionnelle de référence à Kinshasa. Nous formons les techniciens et entrepreneurs de demain.
            </p>
            {/* Social */}
            <div className="flex gap-3">
              {[
                { icon: 'ri-whatsapp-line', href: WA_LINK },
                { icon: 'ri-facebook-line', href: '#' },
                { icon: 'ri-instagram-line', href: '#' },
                { icon: 'ri-youtube-line', href: '#' },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-full text-white/60 hover:border-[#f5c518] hover:text-[#f5c518] transition-all duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Formations */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">
              <a href="#formations">Nos Formations</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {programs.map((p) => (
                <li key={p}>
                  <a
                    href={WA_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white/55 text-sm hover:text-[#f5c518] transition-colors duration-200 cursor-pointer"
                  >
                    {p}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">
              <a href="#hero">Navigation</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {[
                { label: 'Accueil', href: '#hero' },
                { label: 'Formations', href: '#formations' },
                { label: 'Avantages', href: '#avantages' },
                { label: 'Témoignages', href: '#temoignages' },
                { label: 'Contact', href: '#contact' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/55 text-sm hover:text-[#f5c518] transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-5">
              <a href="#contact">Contact</a>
            </h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-[#f5c518] text-base"></i>
                </div>
                <span className="text-white/60 text-sm leading-relaxed">Kinshasa, République Démocratique du Congo</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-[#f5c518] text-base"></i>
                </div>
                <a
                  href={WA_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white/60 text-sm hover:text-[#f5c518] transition-colors cursor-pointer"
                >
                  +243 808 631 779
                </a>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-time-line text-[#f5c518] text-base"></i>
                </div>
                <span className="text-white/60 text-sm">Lun–Sam : 8h00 – 20h00</span>
              </div>
            </div>

            {/* WhatsApp CTA */}
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 flex items-center gap-2 bg-[#f5c518] text-[#0a1628] font-bold text-sm px-5 py-3 rounded-full hover:bg-yellow-400 transition-all duration-200 whitespace-nowrap cursor-pointer w-fit"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line text-base"></i>
              </div>
              Nous écrire
            </a>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">
            © 2024 Campus Négus Tech — Kinshasa, RDC. Tous droits réservés.
          </p>
          <div className="flex gap-6">
            {['Mentions légales', 'Politique de confidentialité', 'CGU'].map((item) => (
              <a
                key={item}
                href="#"
                className="text-white/40 text-xs hover:text-white/70 transition-colors cursor-pointer"
              >
                {item}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
